import { login, login1, logout } from '@/util/login'
import { getToken, setToken, removeToken, removeInfo, getInfo, setInfo } from '@/util/auth'
import router from '../../router/index'
import { Dialog } from 'vant';

const user = {
  state: {
    token: getToken(),
    userInfo: getInfo(),
    permissions: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
  },
  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.phone.trim()
      const code = userInfo.code
      return new Promise((resolve, reject) => {
        login(username, code).then(res => {
          if (res.data.code == "0000") {
            if (res.data.data.access_token) {
              setToken(res.data.data.access_token)
              setInfo(res.data.data.user)
              commit('SET_TOKEN', res.data.data.access_token)
              commit('SET_USERINFO', res.data.data.user)
              if (getToken()) {
                router.push('/index')
              }
            }
          }
          resolve(res.data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    Login1({ commit }, userInfo) {
      const userName = userInfo.userName.trim()
      const password = userInfo.password
      return new Promise((resolve, reject) => {
        login1(userName, password).then(res => {
          if (res.data.code == "0000") {
            if (res.data.data.access_token) {
              setToken(res.data.data.access_token)
              setInfo(res.data.data.user)
              commit('SET_TOKEN', res.data.data.access_token)
              commit('SET_USERINFO', res.data.data.user)
              if (getToken()) {
                router.push('/index')
              }
            }
          } else if (res.data.code == "9999") {
            // this.$toastf(res.data.message);
            Dialog({ message: res.data.message });
          }
          resolve(res.data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then((res) => {
          commit('SET_TOKEN', '')
          commit('SET_USERINFO', '')
          removeToken()
          removeInfo()
          if (res.data.code == "0000") {
            router.push('/index')
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user
